export default "__VITE_ASSET__D7fI2hNm__"